import { BuilderConfig } from '../../types/Builder';

import BusinessHubGateway, { Props } from './business-hub-gateway';

export const FullBleedConfig = {
    name: 'Business Hub Gateways',
    inputs: [
        {
            name: 'title',
            type: 'text',
        },
        {
            name: 'description',
            type: 'text',
        },
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: '#5b9e9b',
        },
        {
            name: 'slides',
            type: 'list',
            required: true,
            defaultValue: [
                {
                    header: 'Step 1',
                    subheader: 'Browse all your favorite places to shop online or in retail stores near you.',
                    body: 'Afterpay works online or in-store wherever you are used to shopping.',
                    backgroundImage: '/iphone-body1.png',
                    imageAltText: 'Image1',
                },
                {
                    header: 'Step 2',
                    subheader: 'Browse all your favorite places to shop online or in retail stores near you.',
                    body: 'Afterpay works online or in-store wherever you are used to shopping.',
                    backgroundImage: '/iphone-body2.png',
                    imageAltText: 'Image2',
                },
            ],
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'description',
                    type: 'string',
                    required: false,
                },
                {
                    name: 'backgroundImage',
                    type: 'file',
                    helperText: 'Use vertical images that are 2-3x resolution to ensure images render nicely on retina devices',
                    allowedFileTypes: ['jpg', 'jpeg', 'png'],
                    required: true,
                },
                {
                    name: 'imageAltText',
                    type: 'string',
                    required: false,
                },
                {
                    name: 'ctaText',
                    type: 'string',
                    required: false,
                },
                {
                    name: 'ctaUrl',
                    type: 'url',
                    required: false,
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<Props> = {
    component: BusinessHubGateway,
    config: FullBleedConfig,
};

export default builderConfig;
